























































































































































































































import { ADMColumn } from '@/interfaces/adm-columns.interface'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { checkPermissions } from '@/directives/permissionDirective'
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import moment from 'moment'
import ReportShare from './ReportShare.vue'
@Component({
    components: {
        ConfirmDialog,
        ReportShare
    }
})
export default class ReportFavorites extends Vue {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() dataList!: any
    @Prop() loading!: boolean
    @Prop() selectRows!: boolean
    @Prop() customColums!: ADMColumn[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() selectedRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() columns!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() dataRows!: any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Prop() pagination!: any
    @Prop() rowsPerPage!: number

    permissionPrefix = 'report'

    confirmDialogShare = false
    confirmDialogTrigger = false
    confirmDialogClone = false
    confirmDialogFavorite = false
    confirmDialogData = null

    @Watch('pagination', { deep: true })
    paginationHandler () {
        this.$emit('paginationTable', this.pagination.currentPage)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    checkOwner (item: any, reportPrivate?: boolean) {
        const userId = this.$store.state.AuthStore.auth.user.userId
        if (reportPrivate) {
            if ((item.reportPrivateEnabled === 1 && (item.userId.userId === userId || userId === 1))) {
                return true
            } else {
                return false
            }
        } else {
            if (item.userId.userId === userId || userId === 1) {
                return true
            } else {
                return false
            }
        }
    }

    checkPermision (permission: string) {
        return !!checkPermissions(permission)
    }

    newLimitHandler (val: number) {
        this.$emit('newLimitHandler', val)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    matchVariableWithArray (variable: string, inputAttibute: string, outputAttibute: string, array: any[], output?: any[]): void|string|number {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const match: any = array.find(item => item[inputAttibute] === variable)
        if (output) output.push(match)
        if (!output) return match ? match[outputAttibute] : '-'
    }

    getDate (dateString: string) {
        return moment(dateString).format('MM/YYYY').toString()
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = (date.getMonth() + 1).toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reportAgend (item: any) {
        this.$emit('reportAgend', item.reportId)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    editField (item: any) {
        this.$emit('editField', item.reportId)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    addRolesField (item: any) {
        this.$emit('addRolesField', item)
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    viewReport (item: any) {
        this.$emit('viewReport', item.reportId)
    }

    confirmedDialog (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('deleteReports', callback.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                }
            })
    }

    confirmedDialogClone (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('cloneReports', callback.reportId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadData')
                }
            })
    }

    confirmedDialogFavorite (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('deleteFavorites', callback.reportFavoriteId)
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.$emit('loadDataFavorite')
                    this.$emit('loadData')
                }
            })
    }

    confirmedDialogShare (callback: {[key: string]: string|number|boolean}) {
        this.$store.dispatch('createReportShares', { reportId: callback.reportId, users: callback.users })
            .then(resp => {
                if (resp?.status === 200) {
                    this.$store.commit('reportSuccess', 'Done Successfully!')
                    this.confirmDialogShare = false
                    this.confirmDialogData = null
                }
            })
    }
}
